module.exports = __webpack_public_path__ + "img/arrow-ios-back-black.e9609e2d.svg";